<template>
  <div>
    <el-card>
      <div class="flex flex-align-center gap-10">
        <div class="keyLabel" style="width:80px">关键字：</div>
        <el-input v-model.trim="keywords" style="width:250px" placeholder="订单号、外部单号"></el-input>
      </div>
      <div class="flex flex-align-center gap-10 margin-top-20">
        <div class="keyLabel" style="width:80px">报单时间：</div>
        <el-date-picker
          v-model="offerTime"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="flex flex-align-center gap-20 margin-top-20">
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel" style="width:80px">订单状态：</div>
          <el-select v-model="state" style="width:120px">
            <el-option v-for="(v,i) in stateList" :value="v.value" :label="v.label"></el-option>
          </el-select>
        </div>
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel" style="width:80px">退款类型：</div>
          <el-select v-model="type" style="width:120px">
            <el-option v-for="(v,i) in typeList" :value="v.value" :label="v.label"></el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
        <buttonPermissions :datas="'XITAIDistributorOrderEnter'">
          <el-dropdown @command="exportOrder">
            <el-button>
              订单录入<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">批量导入</el-dropdown-item>
              <el-dropdown-item command="2">手工录单</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </buttonPermissions>
        <buttonPermissions :datas="'XITAIDistributorOrderExport'">
          <el-button @click="exportFile">导出</el-button>
        </buttonPermissions>
        <el-button type="text" @click="reset">重置筛选条件</el-button>
      </div>
      
      <div class="table-container" style="margin-top:10px">
        <el-table border style="width: 100%;" v-loading="loading" ref="multipleTable" :data="groupData"
          :row-class-name="setClassName" :span-method="arraySpanMethod" :header-row-style="headerStyle">
          <el-table-column label="商品" width="220px">
            <template slot-scope="scope">
              <div class="header-box" v-if='scope.row.type===1'
                :style="{background:scope.row.type == 1?'rgba(64, 158, 255,.1)':'transparents'}">
                <div class="header-info">
                  <el-checkbox v-model="scope.row.check" @change="(e)=>{chooseCheck(e,scope.row)}"> <span></span> </el-checkbox>
                  <span>订单：{{scope.row.OrderNo}}</span>
                  <span>外部单号：{{scope.row.OutOrderNo}}</span>
                  <span>报单时间：{{scope.row.AddTime}}</span>
                  <span>分销商：{{scope.row.EmployeeName}}</span>
                </div>
              </div>
              <div class="product-name-box" v-else-if='scope.row.type===2'>
                <div class="product-name">
                  <span>{{scope.row.ProductName}}</span>
                </div>
              </div>
              <div class="remark-box" v-else>
                <div class="customer-remark" v-if="scope.row.CustomerRemark">
                  买家留言:{{scope.row.CustomerRemark}}</div>
                <div class="system-remark" v-if="scope.row.SystemRemark">
                  系统备注:{{scope.row.SystemRemark}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <div style="color:#606266;">
                <div class="ellipsis" v-if="scope.row.SpecValue || scope.row.SpecValue2">
                  <span v-if="scope.row.SpecValue">{{scope.row.SpecValue}}</span>
                  <span v-if="scope.row.SpecValue2">;{{scope.row.SpecValue2}}</span>
                </div>
                <div v-else>默认规格</div>
                <div class="color-999999">
                  {{scope.row.BarCode}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="数量&单价">
            <template slot-scope="scope">
              <div>
                <div>商品数量：{{scope.row.ProductCount}}</div>
                <div>采购单价：{{scope.row.ProductPrice}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="合计(元)" width="100">
            <template slot-scope="scope">
              <div>
                {{scope.row.ProductMoney}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="收件人" width="320">
            <template slot-scope="scope">
              <div>
                <div>
                  {{scope.row.ReceiveName}}({{scope.row.ReceivePhone}})
                </div>
                <div>
                  {{scope.row.ReceiveProvince + scope.row.ReceiveCity + scope.row.ReceiveArea + scope.row.ReceiveAddress}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="OrderStateValue" label="订单状态" width="80"></el-table-column>
          <el-table-column label="物流信息" width="145">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.ExpressNo">
                  <div>
                    {{scope.row.ExpressValue}}
                  </div>
                  <div>
                    {{scope.row.ExpressNo}}
                  </div>
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="退款信息">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.RefundTypeValue">
                  <div>{{scope.row.RefundTypeValue}}</div>
                  <div>{{scope.row.RefundReason}}</div>
                  <div>{{scope.row.RefundReturnExpressNo}}</div>
                </div>
                <div v-else>--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <div class="flex flex-align-center gap-10 flex-wrap"></div>
              <buttonPermissions :datas="'XITAIDistributorOrderSend'" v-if="scope.row.OrderState==0">
                <el-button type="text" style="color:#f56c6c" @click="cancelOrder(scope.row)">取消订单</el-button>
              </buttonPermissions>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex flex-align-center flex-justify-between margin-top-10">
          <div class="flex flex-align-center gap-10"></div>
          <el-pagination v-if="Total" style="margin-top:10px" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="Total">
          </el-pagination>
        </div>
      </div>
    </el-card>

    <batch-enter :show="batchEnterShow" @close="batchEnterShow=false"></batch-enter>

  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import batchEnter from "../components/batchEnter"
import {
  cittaDistributionOrderlist,
  cittaDistributionOrdercancel,
} from "@/api/sv3.0.0"
import {
  nextDay
} from "@/utils"
export default {
  components: {
    buttonPermissions,
    batchEnter,
  },
  data () {
    return {
      keywords:'',
      offerTime:[],
      state:null,
      stateList:[
        {value:null,label:'全部'},
        {value:0,label:'待审核'},
        {value:10,label:'待发货'},
        {value:20,label:'已发货'},
        {value:30,label:'已取消'},
      ],
      type:null,
      typeList:[
        {value:null,label:'全部'},
        {value:1,label:'仅退款'},
        {value:2,label:'退货退款'},
      ],
      groupData:[],
      loading:false,
      Total:0,
      currentPage:1,
      pageSize:20,
      batchEnterShow:false,
    }
  },
  computed: {
    
  },
  mounted () {
    this.gettablelist()
  },
  methods: {
    cancelOrder(row){
      this.$confirm('操作不可撤消，是否确认取消订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try{
            this.loading = true
            let res = await cittaDistributionOrdercancel({
              OrderNo:row.OrderNo
            })
            if(res.IsSuccess){
              this.$message.success('操作成功')
              this.gettablelist()
            }
          }finally{
            this.loading = false
          }
        })
    },
    exportOrder(e){
      if(e==1){
        this.batchEnterShow = true
      }else{
        this.$router.push({
          path:'/XITAIDistribution/XITAIOrderEnter'
        })
      }
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pageSize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.loading = true
        let data = {
          Type:1,
          Keywords:this.keywords,
          OrderState:this.state,
          RefundType:this.type,
          Skip:(this.currentPage-1)*this.pageSize,
          Take:this.pageSize,
        }
        if(this.offerTime&&this.offerTime.length){
          data.StartTime = this.offerTime[0]
          data.EndTime = nextDay(this.offerTime[1],1)
        }

        let res = await cittaDistributionOrderlist(data)
        if(res.IsSuccess){
          this.Total = res.Result.Total
          this.dealData(res)
        }
      }finally{
        this.loading = false
      }
    },
    dealData(result) {
      let list = result.Result.Results || [];
      this.groupData = []
      list.forEach((t) => {
        let item = {
          type: 1,
          ...t,
          check:false,
        }
        this.groupData.push(item)
        t.OrderDetailList.forEach((tt, ii) => {
          let iitem = {}
          if (ii === 0) {
            iitem = {
              ...tt,
              type: 2,
              length: t.OrderDetailList.length,
              ...t,
            }
          } else {
            iitem = {
              ...tt,
              type: 2,
              OrderNo: t.OrderNo,
              ...t,
            }
          }
          this.groupData.push(iitem)
        })
        if (t.CustomerRemark || t.SystemRemark) {
          let item = {
            type: 3,
            ...t
          }
          this.groupData.push(item)
        }
      })

    },
    headerStyle() {
      return {
        background: '#f0f2f5'
      }
    },
    setClassName({row,index}) {
      if (row.type == 1) {
        return 'special-row'
      }
    },
    arraySpanMethod({row,column,rowIndex,columnIndex}) {
      if (row.type === 1 || row.type === 3) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 10
          };
        } else {
          return {
              rowspan: 0,
              colspan: 0
            };
        }
      }else{
        if(columnIndex>4){
          if (row.length) {
            return {
              rowspan: row.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    reset(){
      this.keywords = ''
      this.offerTime = []
      this.state = null
      this.type = null
      this.handleCurrentChange(1)
    },
    exportFile(){
      let url = location.origin + '/pc/cittaDistributionOrder/export'
      url += '?Type=' + 1
      url += '&Keywords=' + encodeURI(this.keywords)
      url += '&OrderState=' + (this.state==null?'':this.state)
      url += '&RefundType=' + (this.type==null?'':this.type)
      if(this.offerTime&&this.offerTime.length){
        url += '&StartTime=' + this.offerTime[0]
        url += '&EndTime=' + nextDay(this.offerTime[1],1)
      }
      window.open(url)
    }
  }
}
</script>

<style lang='less' scoped>

.keyLabel{
  text-align: right;
}
  .shopBox{
    width: 100%;
    background: #F8F8F9;
    border: 1px solid #EBEEF5;
    padding:10px;

    img{
      width:60px;height:60px
    }
  }
	.table-container {
		::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
			background-color: rgba(0, 0, 0, 0) !important;
		}

		.header-box {
			display: flex;
			padding: 0 10px;
			flex-direction: row;
			justify-content: space-between;
			align-content: center;

			.header-info {
				span {
					display: inline-block;
					line-height: 40px;
					margin-right: 20px;
				}
			}

			.header-btn {
				min-width: 120px;
			}
		}

		.remark-box {
			.remark-distribution{
				background: rgba(245, 244, 247,1);
				color: #f56c6c;
				padding: 10px;
				word-wrap: break-word;
				width: 100%;
			}
			.customer-remark {
				background: rgba(217, 236, 255, 1);
				color: rgba(64, 158, 255, 1);
				padding: 10px;
				word-wrap: break-word;
				width: 100%;
        // padding-left:20px
			}

			.system-remark {
				background: rgba(253, 246, 236, 1);
				color: rgba(253, 162, 60, 1);
				padding: 10px;
				word-wrap: break-word;
				width: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				font-size: 14px;
			}
		}

		.product-name-box {
			.product-name {
				width: 200px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}

		::v-deep .special-row {
			padding-top: 10px;

			td {
				padding: 10px 0 0 0 !important;
			}

			.cell {
				padding: 0 !important;
			}

			.name-wraper {
				padding: 5px 10px;

				.line span {
					line-height: 30px;
					display: inline-block;
				}
			}
		}
	}
</style>